document.addEventListener('DOMContentLoaded', function() {
  console.log('Hero navigation script loaded');
  
  // Debug: Log all available IDs on the page
  const allIds = Array.from(document.querySelectorAll('[id]')).map(el => el.id);
  console.log('All IDs on page:', allIds);
  
  const scrollLinks = document.querySelectorAll('[data-scroll-to]');
  console.log('Found scroll links:', scrollLinks.length);
  
  /**
   * Function to find target element with retry logic returning a Promise
   * @param {string} targetId
   * @param {number} [maxRetries=3]
   * @returns {Promise<HTMLElement | null>}
   */
  function findTargetWithRetry(targetId, maxRetries = 3) {
    return new Promise((resolve) => {
      let retryCount = 0;
      
      function tryFind() {
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          console.log('Target element found after retry:', targetId);
          resolve(targetElement);
          return;
        }
        
        retryCount++;
        if (retryCount < maxRetries) {
          console.log(`Retry ${retryCount}/${maxRetries} for target:`, targetId);
          setTimeout(tryFind, 100); // Wait 100ms and try again
        } else {
          console.log('Max retries reached for target:', targetId);
          resolve(null);
        }
      }
      
      tryFind();
    });
  }
  
  scrollLinks.forEach(link => {
    console.log('Adding click listener to:', link);
    link.addEventListener('click', function(e) {
      console.log('Click event triggered');
      const href = this.getAttribute('href');
      console.log('Clicked href:', href);
      
      // Check if it's an external URL or not an anchor link
      if (!href || !href.startsWith('#')) {
        console.log('External URL, allowing default behavior');
        return;
      }
      
      e.preventDefault();
      console.log('Prevented default behavior');
      
      // Extract target ID from anchor link
      const targetId = href.substring(1);
      console.log('Target ID:', targetId);
      
      // First, try to find the element immediately
      let targetElement = document.getElementById(targetId);
      console.log('Target element found immediately:', !!targetElement);
      
      if (targetElement) {
        console.log('Target element:', targetElement);
        
        // Try native scrollIntoView first (simplest approach)
        try {
          console.log('Attempting native scrollIntoView');
          targetElement.scrollIntoView({ behavior: 'smooth' });
          console.log('Native scrollIntoView completed');
        } catch (error) {
          console.error('Native scrollIntoView failed:', error);
          // Fallback to manual smooth scroll
          console.log('Using manual smooth scroll');
          const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      } else {
        console.warn('Target element not found immediately, will retry:', targetId);
        
        // Use retry logic to find the target element
        findTargetWithRetry(targetId).then(targetElement => {
          if (targetElement) {
            console.log('Target element found via retry:', targetElement);
            try {
              console.log('Attempting native scrollIntoView after retry');
              targetElement.scrollIntoView({ behavior: 'smooth' });
              console.log('Native scrollIntoView completed after retry');
            } catch (error) {
              console.error('Native scrollIntoView failed after retry:', error);
              const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
              window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
              });
            }
          } else {
            console.error('Target element not found after retries:', targetId);
            
            // Try to find any story section as fallback
            const storyFound = findAndScrollToStorySection();
            if (!storyFound) {
              console.log('No story sections found, using fallback scroll');
              // Fallback: scroll down by a large amount (should reach story section)
              window.scrollTo({
                top: window.pageYOffset + 2000,
                behavior: 'smooth'
              });
            }
            
            // Fallback to native browser behavior as last resort
            setTimeout(() => {
              if (window.pageYOffset < 1000) {
                console.log('Fallback to native browser behavior');
                window.location.href = href;
              }
            }, 2000);
          }
        });
      }
    });
  });
});

// Alternative approach: Use CSS-based smooth scrolling as fallback
(function() {
  // Check if smooth scrolling is supported
  const supportsSmoothScroll = 'scrollBehavior' in document.documentElement.style;
  
  if (!supportsSmoothScroll) {
    console.log('Browser does not support smooth scrolling, adding CSS fallback');
    
    // Add CSS for smooth scrolling
    const style = document.createElement('style');
    style.textContent = `
      html {
        scroll-behavior: smooth !important;
      }
    `;
    document.head.appendChild(style);
  }
})();

// Additional fallback: Find all possible story sections and scroll to the first one
function findAndScrollToStorySection() {
  console.log('Looking for story sections...');
  
  // Try different possible selectors for story sections
  const selectors = [
    '[id^="home-story"]',
    '.home-story',
    '[id*="story"]',
    'section.home-story',
    'home-story-slider'
  ];
  
  for (const selector of selectors) {
    try {
      const elements = document.querySelectorAll(selector);
      console.log(`Found ${elements.length} elements with selector:`, selector);
      
      for (const element of elements) {
        const elementId = element.id || element.className;
        console.log('Checking element:', elementId);
        
        if (element && element.getBoundingClientRect().top > 0) {
          console.log('Found valid story section:', elementId);
          element.scrollIntoView({ behavior: 'smooth' });
          return true;
        }
      }
    } catch (e) {
      console.error('Selector error:', selector, e);
    }
  }
  
  console.log('No story sections found');
  return false;
}